import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import BasePlayer from 'services/sports/default/base-player';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';
import {toFloat} from "helpers/number-helper";

export default class Player extends BasePlayer {
    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            grades: parseFloat(expandedPlayer.grades),
            dvp: parseFloat(expandedPlayer.dvp),
            pra: toFloat(expandedPlayer.pra, 3),
            expected_minutes: parseInt(expandedPlayer.expected_minutes),
            points_per_minute: parseFloat(expandedPlayer.points_per_minute),
            userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
                this.captain_exposureMin = getDefaultExposure('min');
                this.captain_exposureMax = getDefaultExposure('max');
            },
        };
    }
}
